const btnFormEquip = {
  text: 'new service'
};

export default btnFormEquip;
